export default {
  title: {
    id: 'services_bouygues_offers_drawer_title',
    defaultMessage: 'Les offres Bouygues en détail',
  },
  closeButtonLabel: {
    id: 'services_bouygues_offers_drawer_close_button_label',
    defaultMessage: 'Fermer Bouygues Telecom assistance',
  },
}
